module.exports = __webpack_public_path__ + "img/menu_mens_placenta.b0bb3109.png";